module.exports = __webpack_public_path__ + "img/newfb.d2902af0.svg";